import { createBrowserRouter } from 'react-router-dom';

import { AppLayout } from './components/AppLayout';
import { ProtectedRoute } from './lib/auth';
import { AssetsPage } from './pages/AssetsPage';
import { AuditPage } from './pages/AuditPage';
import { BumpsPage } from './pages/BumpsPage';
import { CouponsPage } from './pages/CouponsPage';
import { DashboardPage } from './pages/DashboardPage';
import { LeadsPage } from './pages/LeadsPage';
import { LoginPage } from './pages/LoginPage';
import { MetricsPage } from './pages/MetricsPage';
import { OrdersPage } from './pages/OrdersPage';
import { PlansPage } from './pages/PlansPage';
import { SettingsPage } from './pages/SettingsPage';
import { SiteEditorPage } from './pages/SiteEditorPage';
import { SitesPage } from './pages/SitesPage';
import { SubscriptionsPage } from './pages/SubscriptionsPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'leads', element: <LeadsPage /> },
      { path: 'subscriptions', element: <SubscriptionsPage /> },
      { path: 'metrics', element: <MetricsPage /> },
      { path: 'sites', element: <SitesPage /> },
      { path: 'sites/:id', element: <SiteEditorPage /> },
      { path: 'plans', element: <PlansPage /> },
      { path: 'bumps', element: <BumpsPage /> },
      { path: 'coupons', element: <CouponsPage /> },
      { path: 'assets', element: <AssetsPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);
